/*
 * @Description:
 * @Version: 1.0
 * @Autor: hs
 * @Date: 2021-09-07 15:04:39
 * @LastEditors: hs
 * @LastEditTime: 2021-10-14 16:43:51
 */
/**
 * @desc 格式化数字显示
 * @param {String|Number} val 表达式的值
 * @param {Number} [num] 保留 num 位小数
 * @returns {Number}
 */
export default (val, num = 2) => {
  if (val && typeof +val === 'number') {
    return (+val).toFixed(num)
  } else {
    return val
  }
}
